import * as React from "react"
import { navigate } from "gatsby"
import {
  Button,
  Modal,
  ModalCard,
  StyledModal,
  StyledModalHeader,
  StyledModalBody,
  StyledModalActions,
  ThemeCss,
  Text,
} from "gatsby-interface"
import { getPathToOrgPricing } from "@modules/organization/shared/utils"

export type ConnectBlockUpProps = {
  organizationId: string
  isOpen: boolean
  onDissmis: () => void
  quantity?: number | null
}

export function ConnectBlockUp({
  organizationId,
  isOpen = false,
  onDissmis,
  quantity,
}: ConnectBlockUpProps) {
  const handleClick = () => {
    onDissmis()

    navigate(getPathToOrgPricing(organizationId))
  }

  return (
    <Modal isOpen={isOpen} onDismiss={onDissmis}>
      <ModalCard>
        <StyledModal variant="ACTION">
          <StyledModalHeader onCloseButtonClick={onDissmis}>
            You’ve reached your plan limit of{" "}
            <strong css={strongCss}>
              {quantity} third party hosting integrations
            </strong>
            .
          </StyledModalHeader>
          <StyledModalBody>
            <Text>
              To connect with another third party hosting in your workspace,
              upgrade your plan.
            </Text>
            <StyledModalActions>
              <Button
                variant="SECONDARY"
                tone="NEUTRAL"
                type="button"
                onClick={onDissmis}
              >
                Back to site
              </Button>
              <Button variant="PRIMARY" type="submit" onClick={handleClick}>
                Upgrade plan
              </Button>
            </StyledModalActions>
          </StyledModalBody>
        </StyledModal>
      </ModalCard>
    </Modal>
  )
}

/* styles */

const strongCss: ThemeCss = theme => ({
  color: theme.colors.purple[60],
})
